import { Checkbox } from '../Checkbox';
import { StyledQmarkCheckboxes } from './style';
import { useIntl } from 'react-intl';
import React, { useEffect, useState } from 'react';
import { FarmsFilterOptions } from 'types/FilterOptions';
import { Icon } from 'ui';

interface FarmsProps {
  farms: FarmsFilterOptions[] | undefined;
}
export const FarmsCheckboxes = ({ farms }: FarmsProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isEmpty, setIsEmpty] = useState<boolean>();

  const intl = useIntl();

  const handleOnClick = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (farms?.length === 0) {
      setIsOpen(false);
      setIsEmpty(true);
    } else {
      setIsEmpty(false);
    }
  }, [farms]);

  return (
    <StyledQmarkCheckboxes>
      <div
        className={'qmark-filter-title'}
        onClick={!isEmpty ? handleOnClick : undefined}
      >
        <div>{intl.formatMessage({ id: 'form.select_farm' })}</div>
        <div className={`icon ${!isOpen ? 'collapsed' : ''}`}>
          <Icon name="arrow" />
        </div>
      </div>
      {isOpen && <Checkbox name="farm" options={farms} filterView={true} />}
    </StyledQmarkCheckboxes>
  );
};
